import classNames from 'classnames';
import Like from '../like/Like';
import KnowledgeCoin from '../KnowledgeCoin';
import styles from './index.module.scss';

interface LikeAndCoinProps {
    docGuid: string;
    repository: Repository;
    creatorGuid?: string;
    creatorName?: string;
    className?: string;
}

export default function LikeAndCoin(props: LikeAndCoinProps) {
    const {repository, docGuid, creatorName, creatorGuid, className} = props;
    return (
        <div className={styles.commonLikeWrap}>
            <div className={styles.block}>
                <Like docGuid={docGuid} repository={repository} />
            </div>
            <>
                <div className={styles.line}></div>
                <div className={styles.block}>
                    <KnowledgeCoin
                        creatorName={creatorName}
                        creatorGuid={creatorGuid}
                        docGuid={docGuid}
                        repository={repository}
                    />
                </div>
            </>

        </div>
    );
}
